import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';
import { EmrIntegrationDtoSchema } from '../contracts';

const CreateEmrIntegrationRequestDtoSchema = z.object({
  credentials: z.object({ username: z.string(), password: z.string() }),
});

const CreateEmrIntegrationResponseDtoSchema = EmrIntegrationDtoSchema;

export type CreateEmrIntegrationRequestDto = z.infer<
  typeof CreateEmrIntegrationRequestDtoSchema
>;
export type CreateEmrIntegrationResponseDto = z.infer<
  typeof CreateEmrIntegrationResponseDtoSchema
>;

export const createEmrIntegration = (
  dto: CreateEmrIntegrationRequestDto,
  config?: AxiosRequestConfig<CreateEmrIntegrationRequestDto>
) => {
  const data = CreateEmrIntegrationRequestDtoSchema.parse(dto);

  const requestDtoConfig = { authType: 'BASIC', emrIntegration: 'ALIS' };

  return api
    .post('/integrations', { ...data, ...requestDtoConfig }, config)
    .then(responseContract(CreateEmrIntegrationResponseDtoSchema));
};
